(function (ng, window, doc, head, src, module) {

    var dependencies = ["cur.$mask", "ui.router", "ngSanitize", "angularMoment", "ngAnimate", "ngMessages", "ui.calendar", "dndLists", "ngFileUpload", "ngMaterial", "chart.js", "fig.config", "ngCookies", "angularUtils.directives.dirPagination"];
    
    /*
     * we could wrap all js files inside a giant IIFE, and just assign this to a local variable of that function
     * that would allow other files to just reference app directly (or whatever we'd call it)
     * but choosing to not do that since it would be different than how we force everything else to be explicity passed in
     * consistent innit
     */
    window.app = ng.module(module, dependencies);

    if (!String.prototype.includes) {
        String.prototype.includes = function(search, start) {
          'use strict';
          if (typeof start !== 'number') {
            start = 0;
          }
      
          if (start + search.length > this.length) {
            return false;
          } else {
            return this.indexOf(search, start) !== -1;
          }
        };
      }

    app.config(["$mdThemingProvider", function ($mdThemingProvider) {
        var customPrimary = {
            '50': "#667291",
            '100': "#5b6682",
            '200': "#505a73",
            '300': "#464f64",
            '400': "#3b4355",
            '500': "#313746",
            '600': "#262b37",
            '700': "#1c1f28",
            '800': "#111419",
            '900': "#07080a",
            'A100': "#737f9d",
            'A200': "#828da7",
            'A400': "#919ab2",
            'A700': "#000000",
            'contrastDefaultColor': "light"
        };
        $mdThemingProvider
            .definePalette("customPrimary",
                customPrimary);

        var customAccent = {
            '50': "#143031",
            '100': "#1b4144",
            '200': "#225356",
            '300': "#296468",
            '400': "#31767a",
            '500': "#38878d",
            '600': "#46abb1",
            '700': "#55b5bc",
            '800': "#67bdc3",
            '900': "#7ac5ca",
            'A100': "#46abb1",
            'A200': "#3f999f",
            'A400': "#38878d",
            'A700': "#8ccdd1"
        };
        $mdThemingProvider
            .definePalette("customAccent",
                customAccent);

        var customWarn = {
            '50': "#ff7b82",
            '100': "#ff626a",
            '200': "#ff4852",
            '300': "#ff2f3a",
            '400': "#ff1522",
            '500': "#fb000d",
            '600': "#e1000c",
            '700': "#c8000a",
            '800': "#ae0009",
            '900': "#950008",
            'A100': "#ff959a",
            'A200': "#ffaeb3",
            'A400': "#ffc8cb",
            'A700': "#7b0006"
        };
        $mdThemingProvider
            .definePalette("customWarn",
                customWarn);

        var customBackground = {
            '50': "#ffffff",
            '100': "#ffffff",
            '200': "#ffffff",
            '300': "#ffffff",
            '400': "#ffffff",
            '500': "#313746",
            '600': "#f2f2f2",
            '700': "#e6e6e6",
            '800': "#d9d9d9",
            '900': "#cccccc",
            'A100': "#ffffff",
            'A200': "#5a677a",
            'A400': "#5a677a",
            'A700': "#5a677a"
        };
        $mdThemingProvider
            .definePalette("customBackground",
                customBackground);

        $mdThemingProvider.theme("default")
            .primaryPalette("customPrimary")
            .accentPalette("customAccent")
            .warnPalette("customWarn")
            .backgroundPalette("customBackground");

    }]);
    /*
     * BOOTSTRAPPING:
     * TODO: consider
     * by default, each state or modal or anything that makes use of a template will require an http call to retrieve the template (once per template for the remainder of the page being open)
     * what this currently attempts to do is put all templates (using a grunt task) into a single large template, which is loaded before the app is loaded. Then all templates are already known to the templatecache
     * caching response headers will affect both of these strategies
     * we could also do a hybrid (if the large template proves too large/slow), where we grab the full template, but don't actually delay the loading of the app
     * this way, whatever templates are requested before the large template completes will just be normal single requests, but once the full template completes we will be done making template requests
     * 
     * we could also put a subset of templates in the "full" template to - something to expirement with
     * 
     * one (small) benefit to having only the full template and 0 single requests, is that we only would ever have to deploy the full template
    
     * another option would be to place all the templates in script elements in the head at build time, and deploy a large single html file
     */
    if (preFetchTemplates()) {
        ng.injector(["ng"])
            .invoke([
                "$http", function ($http) {
                    $http.get(src)
                        .then(function (response) {
                            /* globals DOMParser: false */
                            var parser = new DOMParser();
                            var d = parser.parseFromString(response.data, "text/html");
                            var scripts = d.getElementsByTagName("script");
                            //learned this one the hard way: https://developer.mozilla.org/en-US/docs/Web/API/Node/appendChild
                            for (var i = 0; i < scripts.length; i++) {
                                var newScript = d.importNode(scripts[i], true);
                                head.appendChild(newScript);
                            }
                        })
                        .finally(function () {
                            bootstrap();
                        });
                }
            ]);
    } else {
        bootstrap();
    }

    function bootstrap() {
        ng.element(doc).ready(function () {
            ng.bootstrap(doc, [module], { strictDi: true });
        });
    }

    /*
     * some builds will have the script[type=text/ng-template] already included in the head, other's will fetch the template html
     */
    function preFetchTemplates() {
        //TODO: this
        return false;
        //var scripts = doc.getElementsByTagName("script");
        //for (var i = 0; i < scripts.length; i++) {
        //    if (scripts[i].type === "text/ng-template") {
        //        return false;
        //    }
        //}
        //return true;
    }

})(window.angular, window, window.document, window.document.head, "/build/templates.min.html", "fig.portal"); // jshint ignore:line
